"use client";

import { ArrowUpRight, Microscope, ShieldCheck, Search, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testing() {
  const heading = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const footer = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const services = [{
    numeral: "I",
    title: "Mold Inspection",
    description: "Comprehensive visual and physical assessments to identify moisture intrusion and fungal growth. We utilize advanced diagnostic tools to pinpoint hidden sources of contamination in your property.",
    icon: Search,
    href: "/ServicesPage"
  }, {
    numeral: "II",
    title: "Air Quality Testing",
    description: "Scientific analysis of indoor air samples to detect airborne mold spores and particulate matter. Our laboratory-verified results provide the empirical data needed for remediation.",
    icon: Microscope,
    href: "/ServicesPage"
  }, {
    numeral: "III",
    title: "Certified Reporting",
    description: "Detailed, evidence-forward documentation suitable for insurance claims and real estate transactions. Every report is signed by our certified experts to ensure professional credibility.",
    icon: FileText,
    href: "/ServicesPage"
  }, {
    numeral: "IV",
    title: "Safety Verification",
    description: "Post-remediation clearance testing to confirm your environment is safe and healthy. We provide the final verification that your property meets strict environmental health standards.",
    icon: ShieldCheck,
    href: "/ContactPage"
  }];
  return <section data-section-id="3728" id="clinical-testing-suite" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 overflow-hidden">
      <div className="mx-auto max-w-7xl">
        {}
        <div ref={heading.ref} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-mono text-xs uppercase tracking-[0.4em] text-primary mb-8">
            Our Expertise
          </span>
          <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-foreground max-w-3xl">
            Precision testing
            <br className="hidden md:block" />
            <span className="text-primary"> for clinical results.</span>
          </h2>
          <div className="mt-12 h-px w-24 bg-border" />
        </div>

        {}
        <div ref={grid.ref} className={`mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-border transition-all duration-1000 ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className="group relative p-10 md:p-12 border-b border-border md:border-b-0 md:border-r last:border-r-0 md:[&:nth-child(2)]:border-r-0 lg:[&:nth-child(2)]:border-r lg:last:border-r-0 transition-colors duration-700 hover:bg-accent/40">
                {}
                <div className="font-default text-primary text-4xl md:text-[40px] leading-none mb-10">
                  {service.numeral}
                </div>

                {}
                <div className="mb-10">
                  <Icon className="size-12 text-primary stroke-[1.5] transition-all duration-700 ease-out group-hover:rotate-[4deg] group-hover:text-secondary" strokeWidth={1.5} />
                </div>

                {}
                <h3 className="font-default font-semibold text-2xl text-foreground mb-5 leading-tight">
                  {service.title}
                </h3>

                {}
                <p className="font-default text-sm text-muted-foreground leading-[1.7] mb-10">
                  {service.description}
                </p>

                {}
                <Link to={service.href} className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] text-foreground hover:text-primary transition-colors duration-500">
                  <span>Learn More</span>
                  <ArrowUpRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>

                {}
                <span className="hidden md:block absolute top-0 right-0 h-full w-px bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />
              </div>;
        })}
        </div>

        {}
        <div ref={footer.ref} className={`mt-20 md:mt-28 flex flex-col items-center text-center transition-all duration-1000 ease-out ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="h-px w-16 bg-border mb-10" />
          <p className="font-default text-lg md:text-xl text-muted-foreground max-w-xl">
            Contact us today to schedule your professional environmental assessment.
          </p>
        </div>
      </div>
    </section>;
}